<div class="ng-bento">
	<form bfmForm [formGroup]="profileForm" [bentoBusyLoader]="isLoaderBusy" (ngSubmit)="profileSubmit()" novalidate
		[validations]="validations">
		<div class="card border-light">
			<div class="card-header">
				<span>
					{{profileForm.get('profileType').value}} Profile
				</span>
			</div>
			<div class="card-body col-sm-6">
				<div class="form-group">
					<label class="bento-label-required"
						[ngClass]="{'text-danger': isControlInValid('name') }" for="profileName">
						<span translate="onvio.reporting.FirmManagementReportProfile.profile.profileName"></span>
					</label>
					<div class="form-inline">
						<input bfmField bfmLabel="Profile name" formControlName="name" id="profileName" (change)="validateUniqueness()"
						[validations]="validations.name" [ngClass]="{'col-sm-12': !profileNameCheckLoader , 'col-sm-11': profileNameCheckLoader}" type="text" class="form-control">
						<span class="pb-5" [bentoBusyLoader]="profileNameCheckLoader" [size]="'sm'"></span>
					</div>
				</div>

				<div class="form-group">
					<div class="form-check">
						<input bfmField formControlName="useProfileDateRange" [value]="false"
							id="useIndividualDateRange" type="radio" class="form-check-input"
							type="radio">
						<label class="form-check-label" for="useIndividualDateRange">
						<span translate="onvio.reporting.FirmManagementReportProfile.profileOption.reportDateRangeRadioReport"></span>
						</label>
					</div>
				</div>

				<div class="form-group">
					<div class="form-check">
						<input bfmField formControlName="useProfileDateRange" [value]="true"
							id="useProfileDateRange" type="radio" class="form-check-input"
							type="radio">
						<label class="form-check-label" for="useProfileDateRange">
							<span translate="onvio.reporting.FirmManagementReportProfile.profileOption.reportDateRangeRadioProfile"></span>
						</label>
					</div>
				</div>

				<div  class="form-group">
					<label class="bento-label-required"
						[ngClass]="{'text-danger': isControlInValid('reportDateRange') }"
						for="reportDateRangeId">
						<span translate="onvio.reporting.FirmManagementReportProfile.profileOption.reportDateRange"></span>
					</label>
					<bento-combobox bfmField required [itemsObservable]="datesData"
						formControlName="reportDateRange" [options]="comboboxOptions"
						id="reportDateRangeId" [rowTemplate]="reportDateRangeTemplate">
					</bento-combobox>
					<ng-template #reportDateRangeTemplate let-$data="data" let-$options="options"
						let-$index="index">
						<div id="reportDateRangeComboLabel">
							<label>{{$data.row.name}}</label>
						</div>
					</ng-template>
				</div>
				<div class="form-group" bfmGroup formGroupName="multidate"
					[errorContainer]="multidategperrorcontainer" [useErrorContainerForFieldErrors]="true"
					(groupValidate)="validateSelectedDates($event)"
					*ngIf="profileForm.get('useProfileDateRange').value && profileForm.get('reportDateRange').value?.id === 'CUSTOM'">
					<div class="row">
						<div class="col-sm-6">
							<label class="bento-label-required" for="startDate"
								[ngClass]="{'text-danger': isControlInValid('multidate.startDate') }">
								<span translate="onvio.reporting.FirmManagementReportProfile.profileOption.reportDateRange.startDate"></span>
							</label>
							<div class="input-group">
								<input bfmField id="fromDate"
									[minDate]="{year: 2001, month: 1, day: 1}"
									class="form-control bento-datepicker"
									formControlName="startDate" ngbDatepicker
									#startDate="ngbDatepicker">
								<button class="btn iconbtn" [bentoDatepickerToggle]="startDate"
									type="button" aria-haspopup="true"
									aria-label="Open calendar" title="Open calendar">
									<i class="bento-icon-calendar icon"></i>
								</button>
							</div>
						</div>
						<div class="col-sm-6">
							<label class="bento-label-required" for="toDate"
								[ngClass]="{'text-danger': isControlInValid('multidate.endDate') }">
								<span translate="onvio.reporting.FirmManagementReportProfile.profileOption.reportDateRange.endDate"></span>
							</label>
							<div class="input-group">
								<input bfmField id="toDate"
									class="form-control bento-datepicker"
									[minDate]="{year: 2001, month: 1, day: 1}"
									formControlName="endDate" ngbDatepicker
									#endDate="ngbDatepicker">
								<button class="btn iconbtn" [bentoDatepickerToggle]="endDate"
									type="button" aria-haspopup="true"
									aria-label="Open calendar" title="Open calendar">
									<i class="bento-icon-calendar icon"></i>
								</button>
							</div>
						</div>
					</div>
					<bfm-error-container #multidategperrorcontainer></bfm-error-container>
				</div>

				<div class="form-group">
					<input class="btn btn-primary mr-3" type="submit" value="Save"
						[disabled]="!isSubmitAllowed">
					<input class="btn btn-default" type="button" value="Cancel" (click)="cancel()">
				</div>
			</div>
		</div>

	</form>
	<!-- Alert Message -->
	<div class="row d-flex justify-content-center">
		<div class="col-sm-6">
			<bento-alert [inline]="true" [items]="alerts">
			</bento-alert>
		</div>
	</div>
</div>
